module.exports = __webpack_public_path__ + "img/budget-animation.6cb37e20.svg";